import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ManageSalesRepService } from 'src/app/services/manage-sales-rep.service';
import { CrudStatusType } from 'src/app/enum/crud-status-type';

@Component({
  selector: 'app-manage-sales-rep-add',
  templateUrl: './manage-sales-rep-add.component.html',
  styleUrls: ['./manage-sales-rep-add.component.scss']
})
export class AddManageSalesRepComponent implements OnInit {
  form: FormGroup;
  paramsid: any;
  userDetails: any = {};

  constructor(private navigate: NavigationService,
    private fb: FormBuilder,
    private ManageSalesRepService: ManageSalesRepService,
    private activateroute: ActivatedRoute,
    private toastr: NotificationService
  ) {
    this.activateroute.params.subscribe((params: any) => {
      this.paramsid = parseInt(params.id);
    });
  }

  ngOnInit(): void {
    this.initializeValidators();
    if (this.paramsid > 0) {
      this.getFormDetails();
    }
  }

  initializeValidators() {
    this.form = this.fb.group({
      salesRepName: ['', [Validators.required, Validators.pattern(/\S/)]],
      salesRepCode: ['', [Validators.required, Validators.pattern(/\S/)]],
    });
  }

  getFormDetails() {
    this.ManageSalesRepService.getmanageSalesRepById(this.paramsid).subscribe((res) => {
      this.userDetails = res;
      this.form.patchValue({
        ...res,
      });
    });
  }

  gotoManageSalesRep() {
    this.navigate.gotoManageSalesRep();
  }

  onsubmit() {
    if (this.form.valid) {
      let payload = {
        ...this.userDetails,
        ...this.form.value
      }
      this.ManageSalesRepService.savemanageSalesRep(payload).subscribe((res) => {
        if (res.crudStatus === CrudStatusType.ExceptionExists) {
          this.toastr.showError(res.additionalInfo);
        }
        else if (res.crudStatus === CrudStatusType.DataAddedSuccessfully) {
          this.toastr.showSuccess("Added successfully!");
          this.gotoManageSalesRep();
        }
        else if (res.crudStatus === CrudStatusType.DataUpdatedSuccessfully) {
          this.toastr.showSuccess("Updated successfully!");
          this.gotoManageSalesRep();
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.toastr.showError("Please fill in all mandatory fields!")
    }
  }

}
